<template>
  <div>
    <!-- Filters -->
    <div class="card">
      <div class="card-body">
        <form>
          <h5 class="card-title">Filtres</h5>
          <div class="row">
            <div class="col-xs-3" style="margin: 10px;">
              <fieldset>
                <label><strong>Période</strong></label>
                <select class="form-control browser-default custom-select"
                        v-model="f_period">
                  <option v-for="(p, i) in periodOptions"
                          :key="i"
                          :value="p"
                          v-text="p">
                  </option>
                </select>
              </fieldset>
            </div>
            <div class="col-xs-3" style="margin: 10px;">
              <fieldset>
                <label><strong>Inclure les postes</strong></label>
                <div class="radio">
                  <label>
                    <input type="radio" id="filterPositions1" value="requiredOnly" checked
                           v-model="f_positions"
                           v-on:change="refresh">
                    Postes francophones requis seulement
                  </label>
                </div>
                <div class="radio">
                  <label>
                    <input type="radio" id="filterPositions2" value="all"
                           v-model="f_positions"
                           v-on:change="refresh">
                    Tous les postes
                  </label>
                </div>
              </fieldset>
            </div>
            <div class="col-xs-6" style="margin: 10px;">
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Breadcrumb -->
    <h5>Ratios d'emplois francophones - {{agencyName}}</h5>

    <!-- Info Fournisseur -->
    <OnRatiosAgencyInfo :agencyId="agencyId" :period="f_period" />

    <!-- Total -->
    <OnRatiosEmploisTotal v-if="ratios.length > 1" :ratios="ratios" />

    <!-- Ratios -->
    <h6>Par Site</h6>
    <table class="table table-sm table-bordered">
      <thead>
      <tr style="background-color: #f0f8ff">
        <th></th>
        <OnRatiosTableHeaders1 />
      </tr>
      <tr style="background-color: #f0f8ff">
        <th>Point de service</th>
        <OnRatiosTableHeaders2 />
      </tr>
      </thead>
      <tbody>
      <tr v-for="(r, i) in ratios" :key="i">
        <td>
          <a :href="siteUrl(r)" @click="siteUrlClick(r)">{{siteName(r)}}</a>
        </td>
        <OnRatiosTableCells :row="r" />
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import OnRatiosAgencyInfo from "@/components/OnRatiosAgencyInfo";
import OnRatiosEmploisTotal from '@/components/OnRatiosEmploisTotal.vue';
import OnRatiosTableHeaders1 from "@/components/OnRatiosTableHeaders1";
import OnRatiosTableHeaders2 from "@/components/OnRatiosTableHeaders2";
import OnRatiosTableCells from "@/components/OnRatiosTableCells";
import axios from 'axios';

function lastYearPeriod() {
  const year = new Date().getFullYear();
  return (year - 2).toString() + '-' + (year - 1).toString();
}

export default {
  name: 'OnRatiosEmploisAgency',
  components: {
    OnRatiosAgencyInfo,
    OnRatiosEmploisTotal,
    OnRatiosTableHeaders1,
    OnRatiosTableHeaders2,
    OnRatiosTableCells
  },
  props: {
    agencyId : String
  },
  data() { return {
    f_period: lastYearPeriod(),
    f_positions: 'requiredOnly',
    ratios: []
  }},
  computed: {
    agencyName() {
      return (this.ratios.length)
          ? this.ratios[0].agency_fr
          : '';
    },
    periodOptions() {
      const result = [];
      const year = new Date().getFullYear();
      for (let i = 2017; i <= year; i++) {
        result.push(
            i.toString() + '-' + (i+1).toString()
        );
      }

      result.reverse();
      return result;
    }
  },
  watch: {
    f_period() {
      this.refresh();
    }
  },
  methods: {
    siteName(r) {
      if (r.point_services_fr) {
        return r.point_services_fr;
      } else {
        return r.agency_fr;
      }
    },
    siteUrl(r) {
      return '/on/ratiosemplois/'
          + this.agencyId
          + '/' + r.point_services_id.toLocaleString()
          + '/' + this.f_period;
    },
    siteUrlClick(r) {
      this.$router.push(this.siteUrl(r));
      return false;
    },
    refresh() {
      axios
          .get(
              this.$root.$data.server_base + '/api/on/ratios_emplois_agency.php',
              {
                params: {
                  agency_id : this.agencyId,
                  period: this.f_period,
                  positions: this.f_positions
                }
              }
          ).then(rsp => {
        this.ratios = rsp.data.ratios;
      });
    }
  },
  mounted() {
    this.refresh();
  }
}

</script>